import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const ContainerSwitch = styled.div`
  position: relative;
`;
export const CheckBoxLabel = styled.label<{
    theme: Theme;
    isActive: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 42px;
  height: 26px;
  border-radius: 15px;
  border: 1.5px solid ${({theme}) => theme.grayBorder};
  background: ${({theme}) => theme.switchDisabled};
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background: ${({theme, isActive}) => isActive ? theme.switchTrack: theme.lightText};
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;
export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  margin-right: 10px;
  width: 42px;
  height: 26px;
  &:checked + ${CheckBoxLabel} {
    background: ${({theme}) => theme.switchEnabled};
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 21px;
      transition: 0.2s;
    }
  }
`;
